{
 "areas": [
  {
   "id": "z02-mole-berths",
   "name": "The Mole and Berths",
   "zone": "Z02",
   "beatId": "beat:z02-mole-berths",
   "anchor": [
    992,
    424
   ],
   "image": "/assets/painted/z02-mole-berths.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    864,
    736
   ],
   "arrival": [
    864,
    736
   ],
   "walkable": [
    [
     [
      120,
      430
     ],
     [
      250,
      380
     ],
     [
      420,
      360
     ],
     [
      560,
      440
     ],
     [
      620,
      440
     ],
     [
      700,
      450
     ],
     [
      800,
      440
     ],
     [
      830,
      470
     ],
     [
      800,
      500
     ],
     [
      900,
      560
     ],
     [
      930,
      600
     ],
     [
      900,
      640
     ],
     [
      780,
      640
     ],
     [
      700,
      650
     ],
     [
      560,
      640
     ],
     [
      440,
      660
     ],
     [
      330,
      680
     ],
     [
      240,
      690
     ],
     [
      180,
      680
     ],
     [
      150,
      620
     ],
     [
      120,
      560
     ]
    ],
    [
     [
      300,
      340
     ],
     [
      420,
      300
     ],
     [
      480,
      340
     ],
     [
      420,
      380
     ],
     [
      330,
      390
     ]
    ],
    [
     [
      780,
      420
     ],
     [
      850,
      410
     ],
     [
      1000,
      400
     ],
     [
      1100,
      380
     ],
     [
      1100,
      430
     ],
     [
      980,
      460
     ],
     [
      820,
      470
     ]
    ],
    [
     [
      790,
      690
     ],
     [
      900,
      700
     ],
     [
      1030,
      740
     ],
     [
      1290,
      820
     ],
     [
      1290,
      860
     ],
     [
      1230,
      880
     ],
     [
      1030,
      820
     ],
     [
      860,
      760
     ],
     [
      780,
      730
     ]
    ],
    [
     [
      900,
      640
     ],
     [
      940,
      640
     ],
     [
      950,
      700
     ],
     [
      900,
      700
     ]
    ],
    [
     [
      800,
      440
     ],
     [
      880,
      440
     ],
     [
      905,
      560
     ],
     [
      845,
      560
     ],
     [
      805,
      500
     ]
    ],
    [
     [
      730,
      640
     ],
     [
      900,
      640
     ],
     [
      930,
      700
     ],
     [
      790,
      720
     ],
     [
      740,
      690
     ]
    ],
    [
     [
      1000,
      300
     ],
     [
      1255,
      262
     ],
     [
      1335,
      250
     ],
     [
      1362,
      262
     ],
     [
      1345,
      292
     ],
     [
      1250,
      292
     ],
     [
      1060,
      330
     ],
     [
      1070,
      352
     ],
     [
      1100,
      382
     ],
     [
      1060,
      390
     ],
     [
      1030,
      360
     ],
     [
      995,
      330
     ]
    ],
    [
     [
      880,
      475
     ],
     [
      1165,
      540
     ],
     [
      1165,
      575
     ],
     [
      905,
      532
     ]
    ]
   ],
   "blocked": [
    [
     [
      225,
      510
     ],
     [
      440,
      510
     ],
     [
      440,
      610
     ],
     [
      225,
      610
     ]
    ],
    [
     [
      290,
      460
     ],
     [
      330,
      460
     ],
     [
      330,
      520
     ],
     [
      290,
      520
     ]
    ],
    [
     [
      430,
      440
     ],
     [
      610,
      440
     ],
     [
      630,
      530
     ],
     [
      600,
      540
     ],
     [
      440,
      500
     ]
    ],
    [
     [
      640,
      490
     ],
     [
      840,
      540
     ],
     [
      840,
      600
     ],
     [
      640,
      550
     ]
    ],
    [
     [
      155,
      470
     ],
     [
      215,
      470
     ],
     [
      215,
      510
     ],
     [
      155,
      510
     ]
    ],
    [
     [
      930,
      610
     ],
     [
      975,
      610
     ],
     [
      975,
      715
     ],
     [
      930,
      715
     ]
    ],
    [
     [
      1090,
      735
     ],
     [
      1200,
      735
     ],
     [
      1200,
      800
     ],
     [
      1090,
      800
     ]
    ],
    [
     [
      536,
      592
     ],
     [
      560,
      592
     ],
     [
      560,
      614
     ],
     [
      536,
      614
     ]
    ],
    [
     [
      576,
      608
     ],
     [
      600,
      608
     ],
     [
      600,
      630
     ],
     [
      576,
      630
     ]
    ],
    [
     [
      670,
      606
     ],
     [
      694,
      606
     ],
     [
      694,
      628
     ],
     [
      670,
      628
     ]
    ],
    [
     [
      783,
      589
     ],
     [
      807,
      589
     ],
     [
      807,
      611
     ],
     [
      783,
      611
     ]
    ],
    [
     [
      850,
      656
     ],
     [
      874,
      656
     ],
     [
      874,
      678
     ],
     [
      850,
      678
     ]
    ],
    [
     [
      718,
      669
     ],
     [
      742,
      669
     ],
     [
      742,
      691
     ],
     [
      718,
      691
     ]
    ],
    [
     [
      293,
      656
     ],
     [
      317,
      656
     ],
     [
      317,
      678
     ],
     [
      293,
      678
     ]
    ],
    [
     [
      196,
      674
     ],
     [
      220,
      674
     ],
     [
      220,
      696
     ],
     [
      196,
      696
     ]
    ],
    [
     [
      1070,
      510
     ],
     [
      1092,
      510
     ],
     [
      1092,
      532
     ],
     [
      1070,
      532
     ]
    ],
    [
     [
      1106,
      528
     ],
     [
      1128,
      528
     ],
     [
      1128,
      550
     ],
     [
      1106,
      550
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       925,
       580
      ],
      [
       1050,
       540
      ],
      [
       1050,
       620
      ],
      [
       980,
       720
      ],
      [
       925,
       720
      ]
     ],
     "depth": 716
    },
    {
     "polygon": [
      [
       636,
       491
      ],
      [
       670,
       502
      ],
      [
       704,
       511
      ],
      [
       746,
       523
      ],
      [
       789,
       535
      ],
      [
       813,
       541
      ],
      [
       833,
       548
      ],
      [
       844,
       571
      ],
      [
       845,
       605
      ],
      [
       808,
       592
      ],
      [
       772,
       580
      ],
      [
       731,
       570
      ],
      [
       686,
       553
      ],
      [
       636,
       539
      ]
     ],
     "depth": 600
    },
    {
     "polygon": [
      [
       428,
       435
      ],
      [
       632,
       435
      ],
      [
       632,
       540
      ],
      [
       428,
       540
      ]
     ],
     "depth": 538
    }
   ],
   "lamps": [
    [
     210,
     475
    ],
    [
     258,
     488
    ],
    [
     50,
     660
    ],
    [
     205,
     775
    ],
    [
     822,
     675
    ],
    [
     903,
     727
    ],
    [
     1205,
     818
    ],
    [
     652,
     410
    ],
    [
     1048,
     290
    ],
    [
     1257,
     262
    ],
    [
     1390,
     105
    ],
    [
     135,
     277
    ]
   ],
   "water": [
    [
     [
      340,
      700
     ],
     [
      530,
      690
     ],
     [
      760,
      705
     ],
     [
      780,
      760
     ],
     [
      1030,
      850
     ],
     [
      1200,
      900
     ],
     [
      1300,
      930
     ],
     [
      1300,
      1024
     ],
     [
      480,
      1024
     ],
     [
      340,
      860
     ]
    ],
    [
     [
      1120,
      440
     ],
     [
      1240,
      430
     ],
     [
      1240,
      560
     ],
     [
      1160,
      580
     ],
     [
      1110,
      520
     ]
    ]
   ],
   "smoke": [
    [
     135,
     270
    ],
    [
     258,
     480
    ]
   ],
   "people": [
    {
     "id": "person:z02-mole-berths-0",
     "appearance": "actor-kiln-worker",
     "name": "Stevedore",
     "route": [
      [
       976,
       784
      ],
      [
       1168,
       840
      ]
     ]
    },
    {
     "id": "person:z02-mole-berths-1",
     "appearance": "actor-z02-quay-guard",
     "name": "Quay guard",
     "route": [
      [
       420,
       630
      ],
      [
       860,
       620
      ]
     ]
    },
    {
     "id": "person:mole-rope-worker",
     "appearance": "actor-kiln-worker",
     "name": "Rope tender",
     "route": [
      [
       624,
       640
      ],
      [
       656,
       624
      ],
      [
       688,
       640
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z02-sale-court",
     "label": "Steps up to the sale court",
     "toBeat": "beat:z02-sale-court",
     "at": [
      176,
      640
     ],
     "text": "The sale platform's steps climb from the quay into the court."
    },
    {
     "id": "beat:z02-bonded-warehouse",
     "label": "Warehouse doors",
     "toBeat": "beat:z02-bonded-warehouse",
     "at": [
      720,
      448
     ],
     "text": "The bonded warehouse stands open for cargo."
    },
    {
     "id": "beat:z02-rope-walk",
     "label": "Along the outer mole",
     "toBeat": "beat:z02-rope-walk",
     "at": [
      1072,
      400
     ],
     "text": "The outer mole runs on to the rope walk and the shrine."
    },
    {
     "id": "z02-canal-boat",
     "label": "Canal boat to the Silt Stair",
     "toBeat": "beat:lower-landing",
     "at": [
      1216,
      848
     ],
     "text": "Canal boats tie up at the end of the timber pier. One goes back up the lower canal to the Silt Stair whenever it is full."
    }
   ],
   "objects": [
    {
     "id": "z02-mole-tide-slate",
     "beatId": "beat:z02-mole-berths",
     "name": "The tide slate",
     "at": [
      1340,
      278
     ],
     "radius": 36,
     "actions": [
      "z02-tide"
     ],
     "look": "A slate at the foot of the light, chalked with the tide hours and the pilots who read them."
    },
    {
     "id": "z02-mole-gangway",
     "beatId": "beat:z02-mole-berths",
     "name": "The hull’s gangway",
     "at": [
      1360,
      740
     ],
     "radius": 40,
     "actions": [
      "z02-hull-fight"
     ],
     "look": "The fleet’s smallest hull, tied up at the end of the timber pier."
    }
   ]
  },
  {
   "id": "z02-bonded-warehouse",
   "name": "The Bonded Warehouse",
   "zone": "Z02",
   "beatId": "beat:z02-bonded-warehouse",
   "anchor": [
    800,
    560
   ],
   "image": "/assets/painted/z02-bonded-warehouse.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    480,
    544
   ],
   "arrival": [
    480,
    544
   ],
   "walkable": [
    [
     [
      430,
      520
     ],
     [
      520,
      480
     ],
     [
      640,
      440
     ],
     [
      830,
      405
     ],
     [
      960,
      420
     ],
     [
      1060,
      392
     ],
     [
      1150,
      375
     ],
     [
      1300,
      372
     ],
     [
      1310,
      400
     ],
     [
      1150,
      410
     ],
     [
      1100,
      440
     ],
     [
      1095,
      600
     ],
     [
      1190,
      625
     ],
     [
      1100,
      665
     ],
     [
      960,
      705
     ],
     [
      850,
      760
     ],
     [
      780,
      790
     ],
     [
      690,
      775
     ],
     [
      675,
      600
     ],
     [
      600,
      572
     ],
     [
      450,
      560
     ]
    ]
   ],
   "blocked": [
    [
     [
      832,
      420
     ],
     [
      888,
      420
     ],
     [
      888,
      500
     ],
     [
      832,
      500
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       828,
       140
      ],
      [
       892,
       140
      ],
      [
       892,
       505
      ],
      [
       828,
       505
      ]
     ],
     "depth": 502
    },
    {
     "polygon": [
      [
       430,
       570
      ],
      [
       672,
       570
      ],
      [
       672,
       765
      ],
      [
       430,
       765
      ]
     ],
     "depth": 762
    },
    {
     "polygon": [
      [
       1100,
       410
      ],
      [
       1250,
       410
      ],
      [
       1250,
       640
      ],
      [
       1190,
       640
      ],
      [
       1100,
       600
      ]
     ],
     "depth": 620
    }
   ],
   "lamps": [
    [
     360,
     395
    ],
    [
     676,
     292
    ],
    [
     882,
     352
    ],
    [
     1190,
     490
    ],
    [
     1393,
     318
    ],
    [
     396,
     748
    ],
    [
     298,
     622
    ]
   ],
   "water": [
    [
     [
      0,
      800
     ],
     [
      120,
      780
     ],
     [
      200,
      1024
     ],
     [
      0,
      1024
     ]
    ]
   ],
   "smoke": [],
   "people": [
    {
     "id": "person:z02-bonded-warehouse-0",
     "appearance": "actor-z02-dock-worker",
     "name": "Stevedore",
     "route": [
      [
       720,
       560
      ],
      [
       1000,
       620
      ]
     ]
    },
    {
     "id": "person:z02-bonded-warehouse-1",
     "appearance": "actor-z02-quay-guard",
     "name": "Warehouse guard",
     "route": [
      [
       1180,
       400
      ],
      [
       980,
       440
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z02-mole-berths",
     "label": "Cargo doors to the quay",
     "toBeat": "beat:z02-mole-berths",
     "at": [
      456,
      544
     ],
     "text": "The cargo doors open onto the mole."
    },
    {
     "id": "beat:z02-sale-court",
     "label": "Counting-room door",
     "toBeat": "beat:z02-sale-court",
     "at": [
      1288,
      388
     ],
     "text": "A narrow door behind the counter leads through to the sale court."
    }
   ]
  },
  {
   "id": "z02-rope-walk",
   "name": "The Rope Walk",
   "zone": "Z02",
   "beatId": "beat:z02-rope-walk",
   "anchor": [
    768,
    560
   ],
   "image": "/assets/painted/z02-rope-walk.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    224,
    840
   ],
   "arrival": [
    224,
    840
   ],
   "walkable": [
    [
     [
      150,
      470
     ],
     [
      250,
      440
     ],
     [
      400,
      440
     ],
     [
      480,
      400
     ],
     [
      800,
      390
     ],
     [
      900,
      360
     ],
     [
      1100,
      300
     ],
     [
      1250,
      270
     ],
     [
      1400,
      280
     ],
     [
      1480,
      310
     ],
     [
      1470,
      345
     ],
     [
      1300,
      400
     ],
     [
      1100,
      470
     ],
     [
      900,
      560
     ],
     [
      700,
      620
     ],
     [
      560,
      660
     ],
     [
      420,
      700
     ],
     [
      330,
      730
     ],
     [
      300,
      790
     ],
     [
      230,
      860
     ],
     [
      140,
      890
     ],
     [
      100,
      850
     ],
     [
      190,
      760
     ],
     [
      170,
      640
     ],
     [
      150,
      560
     ]
    ],
    [
     [
      200,
      370
     ],
     [
      300,
      340
     ],
     [
      390,
      420
     ],
     [
      300,
      460
     ],
     [
      210,
      440
     ]
    ],
    [
     [
      1400,
      240
     ],
     [
      1500,
      200
     ],
     [
      1510,
      260
     ],
     [
      1480,
      300
     ],
     [
      1420,
      290
     ]
    ]
   ],
   "blocked": [
    [
     [
      310,
      490
     ],
     [
      410,
      490
     ],
     [
      410,
      620
     ],
     [
      310,
      620
     ]
    ],
    [
     [
      470,
      450
     ],
     [
      550,
      450
     ],
     [
      550,
      570
     ],
     [
      470,
      570
     ]
    ],
    [
     [
      570,
      505
     ],
     [
      620,
      505
     ],
     [
      620,
      560
     ],
     [
      570,
      560
     ]
    ],
    [
     [
      670,
      400
     ],
     [
      760,
      400
     ],
     [
      760,
      520
     ],
     [
      670,
      520
     ]
    ],
    [
     [
      740,
      430
     ],
     [
      800,
      430
     ],
     [
      800,
      500
     ],
     [
      740,
      500
     ]
    ],
    [
     [
      820,
      350
     ],
     [
      890,
      350
     ],
     [
      890,
      450
     ],
     [
      820,
      450
     ]
    ],
    [
     [
      920,
      330
     ],
     [
      1000,
      330
     ],
     [
      1000,
      440
     ],
     [
      920,
      440
     ]
    ],
    [
     [
      1080,
      300
     ],
     [
      1140,
      300
     ],
     [
      1140,
      390
     ],
     [
      1080,
      390
     ]
    ],
    [
     [
      1150,
      270
     ],
     [
      1220,
      270
     ],
     [
      1220,
      360
     ],
     [
      1150,
      360
     ]
    ],
    [
     [
      1270,
      250
     ],
     [
      1320,
      250
     ],
     [
      1320,
      320
     ],
     [
      1270,
      320
     ]
    ],
    [
     [
      140,
      480
     ],
     [
      250,
      480
     ],
     [
      250,
      545
     ],
     [
      140,
      545
     ]
    ],
    [
     [
      220,
      640
     ],
     [
      340,
      640
     ],
     [
      340,
      730
     ],
     [
      220,
      730
     ]
    ],
    [
     [
      631,
      587
     ],
     [
      659,
      587
     ],
     [
      659,
      611
     ],
     [
      631,
      611
     ]
    ],
    [
     [
      831,
      517
     ],
     [
      859,
      517
     ],
     [
      859,
      541
     ],
     [
      831,
      541
     ]
    ],
    [
     [
      1036,
      447
     ],
     [
      1064,
      447
     ],
     [
      1064,
      471
     ],
     [
      1036,
      471
     ]
    ],
    [
     [
      1196,
      387
     ],
     [
      1224,
      387
     ],
     [
      1224,
      411
     ],
     [
      1196,
      411
     ]
    ],
    [
     [
      456,
      664
     ],
     [
      484,
      664
     ],
     [
      484,
      688
     ],
     [
      456,
      688
     ]
    ],
    [
     [
      246,
      582
     ],
     [
      274,
      582
     ],
     [
      274,
      606
     ],
     [
      246,
      606
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       305,
       480
      ],
      [
       415,
       480
      ],
      [
       415,
       625
      ],
      [
       305,
       625
      ]
     ],
     "depth": 622
    },
    {
     "polygon": [
      [
       465,
       440
      ],
      [
       555,
       440
      ],
      [
       555,
       572
      ],
      [
       465,
       572
      ]
     ],
     "depth": 570
    },
    {
     "polygon": [
      [
       665,
       390
      ],
      [
       765,
       390
      ],
      [
       765,
       522
      ],
      [
       665,
       522
      ]
     ],
     "depth": 520
    },
    {
     "polygon": [
      [
       815,
       340
      ],
      [
       895,
       340
      ],
      [
       895,
       452
      ],
      [
       815,
       452
      ]
     ],
     "depth": 450
    },
    {
     "polygon": [
      [
       915,
       325
      ],
      [
       1005,
       325
      ],
      [
       1005,
       442
      ],
      [
       915,
       442
      ]
     ],
     "depth": 440
    },
    {
     "polygon": [
      [
       1075,
       290
      ],
      [
       1225,
       290
      ],
      [
       1225,
       392
      ],
      [
       1075,
       392
      ]
     ],
     "depth": 390
    }
   ],
   "lamps": [
    [
     165,
     320
    ],
    [
     230,
     300
    ],
    [
     268,
     312
    ],
    [
     65,
     540
    ],
    [
     45,
     770
    ],
    [
     1395,
     120
    ],
    [
     1218,
     238
    ]
   ],
   "water": [
    [
     [
      520,
      760
     ],
     [
      900,
      640
     ],
     [
      1150,
      560
     ],
     [
      1200,
      640
     ],
     [
      1180,
      1024
     ],
     [
      560,
      1024
     ]
    ],
    [
     [
      1230,
      490
     ],
     [
      1536,
      430
     ],
     [
      1536,
      640
     ],
     [
      1300,
      560
     ]
    ]
   ],
   "smoke": [
    [
     165,
     312
    ],
    [
     45,
     760
    ]
   ],
   "people": [
    {
     "id": "person:z02-rope-walk-0",
     "appearance": "actor-z02-dock-worker",
     "name": "Ropemaker",
     "route": [
      [
       600,
       580
      ],
      [
       1000,
       450
      ]
     ]
    },
    {
     "id": "person:z02-rope-walk-1",
     "appearance": "actor-z02-quay-guard",
     "name": "Quay guard",
     "route": [
      [
       440,
       470
      ],
      [
       800,
       420
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z02-mole-berths",
     "label": "Steps down to the mole",
     "toBeat": "beat:z02-mole-berths",
     "at": [
      176,
      872
     ],
     "text": "The worn steps drop to the berths."
    },
    {
     "id": "beat:z02-sale-court",
     "label": "Stair up to the sale court",
     "toBeat": "beat:z02-sale-court",
     "at": [
      1456,
      240
     ],
     "text": "Past the turning wheel, a stair climbs to the sale court."
    }
   ],
   "objects": [
    {
     "id": "z02-rope-shrine",
     "beatId": "beat:z02-rope-walk",
     "name": "The harbour shrine",
     "at": [
      310,
      440
     ],
     "radius": 40,
     "actions": [
      "z02-shrine-cord",
      "continuation-grave-witness-held",
      "continuation-grave-witness-open"
     ],
     "look": "The Compact swears its guarantees here. An oath cord hangs from the lintel, knotted along its length."
    }
   ]
  },
  {
   "id": "z02-sale-court",
   "name": "The Sale Court",
   "zone": "Z02",
   "beatId": "beat:z02-sale-court",
   "anchor": [
    768,
    560
   ],
   "image": "/assets/painted/z02-sale-court.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    250,
    700
   ],
   "arrival": [
    250,
    700
   ],
   "walkable": [
    [
     [
      250,
      560
     ],
     [
      420,
      530
     ],
     [
      560,
      480
     ],
     [
      600,
      420
     ],
     [
      700,
      410
     ],
     [
      1000,
      440
     ],
     [
      1030,
      470
     ],
     [
      1020,
      520
     ],
     [
      1030,
      600
     ],
     [
      1110,
      620
     ],
     [
      1170,
      720
     ],
     [
      1160,
      760
     ],
     [
      1260,
      840
     ],
     [
      1330,
      880
     ],
     [
      1250,
      900
     ],
     [
      1150,
      800
     ],
     [
      1080,
      720
     ],
     [
      960,
      700
     ],
     [
      860,
      660
     ],
     [
      640,
      700
     ],
     [
      480,
      720
     ],
     [
      380,
      700
     ],
     [
      330,
      690
     ],
     [
      260,
      760
     ],
     [
      200,
      800
     ],
     [
      140,
      760
     ],
     [
      210,
      690
     ],
     [
      250,
      640
     ]
    ],
    [
     [
      700,
      360
     ],
     [
      960,
      350
     ],
     [
      1000,
      410
     ],
     [
      980,
      440
     ],
     [
      700,
      420
     ]
    ],
    [
     [
      1000,
      440
     ],
     [
      1030,
      462
     ],
     [
      1100,
      468
     ],
     [
      1150,
      498
     ],
     [
      1150,
      535
     ],
     [
      1110,
      540
     ],
     [
      1030,
      540
     ],
     [
      1015,
      520
     ]
    ]
   ],
   "blocked": [
    [
     [
      1030,
      540
     ],
     [
      1110,
      540
     ],
     [
      1110,
      610
     ],
     [
      1030,
      610
     ]
    ],
    [
     [
      286,
      642
     ],
     [
      314,
      642
     ],
     [
      314,
      666
     ],
     [
      286,
      666
     ]
    ],
    [
     [
      343,
      654
     ],
     [
      371,
      654
     ],
     [
      371,
      678
     ],
     [
      343,
      678
     ]
    ],
    [
     [
      472,
      688
     ],
     [
      500,
      688
     ],
     [
      500,
      712
     ],
     [
      472,
      712
     ]
    ],
    [
     [
      512,
      694
     ],
     [
      540,
      694
     ],
     [
      540,
      718
     ],
     [
      512,
      718
     ]
    ],
    [
     [
      852,
      650
     ],
     [
      880,
      650
     ],
     [
      880,
      674
     ],
     [
      852,
      674
     ]
    ],
    [
     [
      554,
      464
     ],
     [
      582,
      464
     ],
     [
      582,
      488
     ],
     [
      554,
      488
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       1180,
       620
      ],
      [
       1300,
       620
      ],
      [
       1300,
       700
      ],
      [
       1180,
       700
      ]
     ],
     "depth": 700
    },
    {
     "polygon": [
      [
       840,
       640
      ],
      [
       890,
       630
      ],
      [
       890,
       700
      ],
      [
       840,
       700
      ]
     ],
     "depth": 690
    }
   ],
   "lamps": [
    [
     90,
     470
    ],
    [
     360,
     395
    ],
    [
     597,
     290
    ],
    [
     715,
     325
    ],
    [
     965,
     330
    ],
    [
     1320,
     355
    ],
    [
     1400,
     685
    ],
    [
     1425,
     345
    ],
    [
     1240,
     190
    ],
    [
     640,
     390
    ]
   ],
   "water": [
    [
     [
      90,
      90
     ],
     [
      640,
      90
     ],
     [
      640,
      130
     ],
     [
      300,
      200
     ],
     [
      90,
      200
     ]
    ]
   ],
   "smoke": [
    [
     715,
     318
    ],
    [
     965,
     322
    ]
   ],
   "people": [
    {
     "id": "person:z02-sale-court-0",
     "appearance": "actor-z02-quay-guard",
     "name": "Court guard",
     "route": [
      [
       700,
       460
      ],
      [
       960,
       470
      ]
     ]
    },
    {
     "id": "person:z02-sale-court-1",
     "appearance": "actor-z02-dock-worker",
     "name": "Porter",
     "route": [
      [
       420,
       560
      ],
      [
       640,
       620
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z02-rope-walk",
     "label": "Stair down to the rope walk",
     "toBeat": "beat:z02-rope-walk",
     "at": [
      208,
      768
     ],
     "text": "Worn steps drop past the rope frames to the rope walk."
    },
    {
     "id": "beat:z02-bonded-warehouse",
     "label": "Passage to the warehouses",
     "toBeat": "beat:z02-bonded-warehouse",
     "at": [
      1264,
      864
     ],
     "text": "The lower passage runs down to the bonded warehouse."
    },
    {
     "id": "beat:z02-mole-berths",
     "label": "Down to the berths",
     "toBeat": "beat:z02-mole-berths",
     "at": [
      400,
      544
     ],
     "text": "Between the cargo stalls, a lane leads down to the mole."
    }
   ]
  }
 ]
}
